<template>
  <div class="auth-container">
    <div class="auth-box">
      <section class="auth-aside">
        <button class="auth-brand" @click="$router.push('/')"><span><nricon name="reading" /></span> 翻书</button>
        <div class="aside-copy">
          <h1>故事还在，<br>等你回来。</h1>
          <p>书页会记得你停下的位置。登录后，继续上一次没有读完的旅程。</p>
        </div>
        <div class="aside-quote">“书是随时携带的避难所。”</div>
      </section>
      <section class="auth-main">
        <button class="home-link" @click="$router.push('/')"><nricon name="close" /><span class="sr-only">返回首页</span></button>
        <div class="auth-header">
          <h2>登录账号</h2>
          <p class="subtitle">继续管理书架、进度与笔记</p>
        </div>
        <form class="auth-form" @submit.prevent="handleLogin">
          <div class="nr-field">
            <label class="nr-field__label" for="login-username">用户名</label>
            <div class="input-wrap">
              <nricon name="user" />
              <input id="login-username" v-model="loginForm.username" class="nr-input has-icon" placeholder="3—20 个字符" autocomplete="username">
            </div>
            <div class="nr-field__error">{{ errors.username }}</div>
          </div>
          <div class="nr-field">
            <label class="nr-field__label" for="login-password">密码</label>
            <div class="input-wrap">
              <nricon name="lock" />
              <input id="login-password" v-model="loginForm.password" type="password" class="nr-input has-icon" placeholder="至少 6 个字符" autocomplete="current-password" @keyup.enter="handleLogin">
            </div>
            <div class="nr-field__error">{{ errors.password }}</div>
          </div>
          <button type="submit" class="btn btn--primary btn--block submit-btn" :disabled="loading">
            <nricon v-if="loading" name="loading" />
            <span v-else>进入我的书库</span>
          </button>
          <div class="form-footer">
            <p>还没有账号？<router-link to="/register" class="link">创建一个</router-link></p>
          </div>
        </form>
      </section>
    </div>
  </div>
</template>

<script>
import api from '@/api'

export default {
  name: 'LoginComponent',
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      errors: { username: '', password: '' },
      loading: false
    }
  },
  methods: {
    validate() {
      this.errors = { username: '', password: '' }
      const u = this.loginForm.username.trim()
      const p = this.loginForm.password
      let ok = true
      if (!u) { this.errors.username = '请输入用户名'; ok = false }
      else if (u.length < 3 || u.length > 20) { this.errors.username = '长度在 3 到 20 个字符'; ok = false }
      if (!p) { this.errors.password = '请输入密码'; ok = false }
      else if (p.length < 6 || p.length > 20) { this.errors.password = '长度在 6 到 20 个字符'; ok = false }
      return ok
    },
    async handleLogin() {
      if (!this.validate()) return
      try {
        this.loading = true
        const { data: loginData } = await api.user.login(this.loginForm)
        localStorage.setItem('token', loginData.token)
        this.$store.commit('setToken', loginData.token)
        const { data: userData } = await api.user.getUserInfo()
        this.$store.commit('setUser', userData)
        try {
          const { data: settings } = await api.settings.getUserSettings()
          this.$store.commit('setUserSettings', settings)
        } catch (e) {
          // ignore settings load error
        }
        this.$message.success('登录成功')
        const redirect = this.$route.query.redirect
        const target = typeof redirect === 'string' && redirect.charAt(0) === '/' && redirect.charAt(1) !== '/' ? redirect : '/'
        this.$router.push(target)
      } catch (error) {
        console.error('登录失败:', error)
        this.$message.error(error.response?.data?.message || '登录失败，请重试')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.auth-container {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--nr-bg);
  padding: 20px;
}

.auth-box {
  background: var(--nr-surface);
  border: 1px solid var(--nr-border);
  padding: 32px;
  border-radius: var(--nr-radius-lg);
  box-shadow: var(--nr-shadow);
  width: 100%;
  max-width: 380px;
}

.auth-header {
  text-align: center;
  margin-bottom: 28px;

  .avatar {
    width: 64px; height: 64px;
    margin: 0 auto 16px;
    border-radius: 50%;
    background: var(--nr-accent-bg);
    display: flex; align-items: center; justify-content: center;
    i { font-size: 32px; color: var(--nr-accent); }
  }
  h2 { color: var(--nr-text); margin: 0; font-size: 22px; font-weight: 500; }
  .subtitle { color: var(--nr-text-3); margin: 8px 0 0; font-size: 14px; }
}

.input-wrap {
  position: relative;
  > i {
    position: absolute; left: 12px; top: 50%; transform: translateY(-50%);
    color: var(--nr-text-3); font-size: 16px;
  }
  .has-icon { padding-left: 36px; }
}

.submit-btn { height: 40px; margin-top: 6px; }

.form-footer {
  text-align: center;
  margin-top: 18px;
  p { color: var(--nr-text-2); font-size: 14px; margin: 0; }
  .link { color: var(--nr-accent); text-decoration: none; &:hover { text-decoration: underline; } }
}
</style>

<style lang="scss" scoped>
.auth-container {
  min-height: 100vh;
  padding: 34px;
  background: var(--nr-bg);
}

.auth-box {
  display: grid;
  width: min(100%, 960px);
  max-width: none;
  min-height: 620px;
  grid-template-columns: 1.05fr .95fr;
  padding: 0;
  overflow: hidden;
  border: 1px solid var(--nr-border);
  border-radius: var(--nr-radius-xl);
  box-shadow: var(--nr-shadow-float);
}

.auth-aside {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 42px;
  overflow: hidden;
  color: #f8f0e5;
  background: #25221e;
}

.auth-brand {
  z-index: 1;
  display: inline-flex;
  align-self: flex-start;
  align-items: center;
  gap: 10px;
  min-height: 44px;
  padding: 0;
  color: #fff8ee;
  border: 0;
  background: transparent;
  font-family: var(--nr-font-display);
  font-size: 20px;
  font-weight: 600;
  cursor: pointer;

  > span { display: grid; width: 34px; height: 34px; place-items: center; border-radius: 50% 50% 50% 11px; background: var(--nr-accent); }
}

.aside-copy {
  z-index: 1;
  margin-block: auto;

  .nr-kicker { color: var(--nr-accent); }
  h1 { margin: 14px 0 24px; color: #fffaf2; font-family: var(--nr-font-display); font-size: clamp(45px, 5vw, 65px); font-weight: 600; line-height: 1.08; letter-spacing: -.045em; }
  p { max-width: 360px; margin: 0; color: #bfb5a7; font-family: var(--nr-font-display); font-size: 15px; line-height: 1.9; }
}

.aside-quote { z-index: 1; color: #9d9488; font-family: var(--nr-font-display); font-size: 13px; }

.auth-main {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: clamp(36px, 6vw, 70px);
  background: var(--nr-surface);
}

.home-link {
  position: absolute;
  top: 24px;
  right: 24px;
  display: grid;
  width: 44px;
  height: 44px;
  place-items: center;
  color: var(--nr-text-3);
  border: 0;
  border-radius: 50%;
  background: transparent;
  cursor: pointer;

  &:hover { color: var(--nr-text); background: var(--nr-surface-2); }
}

.auth-header {
  margin-bottom: 34px;
  text-align: left;

  h2 { margin-top: 8px; font-family: var(--nr-font-display); font-size: 36px; font-weight: 600; letter-spacing: -.035em; }
  .subtitle { margin-top: 7px; }
}

.input-wrap > i { left: 15px; }
.input-wrap .has-icon { height: 48px; padding-left: 42px; }
.nr-field { margin-bottom: 13px; }
.nr-field__label { font-size: 12px; }
.submit-btn { height: 48px; margin-top: 8px; border-radius: 12px; }
.form-footer { margin-top: 22px; }
.form-footer .link { color: var(--nr-accent-text); font-weight: 600; }

@media (max-width: 760px) {
  .auth-container { align-items: flex-start; padding: 0; }
  .auth-box { min-height: 100vh; grid-template-columns: 1fr; border: 0; border-radius: 0; }
  .auth-aside { min-height: 250px; padding: 28px 24px; }
  .aside-copy { margin-top: 48px; }
  .aside-copy h1 { margin: 9px 0 0; font-size: 42px; }
  .aside-copy p,
  .aside-quote { display: none; }
  .auth-main { justify-content: flex-start; padding: 46px 24px 54px; }
  .home-link { top: 18px; right: 18px; color: #f2e9dd; background: rgba(255,255,255,.08); transform: translateY(-228px); }
  .auth-header h2 { font-size: 32px; }
}
</style>
